/* Custom Reaven — box "Avvisami quando torna" / "Avvisami al lancio" (snippets/avvisami.liquid).
   - SMS: spuntando la casella compare il numero; il numero diventa l'etichetta sms-39<numero>
     (il modulo cliente di Shopify il telefono non lo salva: lo copia un flow di Shopify Flow).
     L'etichetta si aggiorna mentre si scrive, cosi' non dipende dall'ordine degli eventi di invio
     (il controllo anti-bot di Shopify intercetta l'invio del modulo).
   - cambio taglia (evento variant-change di Dawn): aggiorna etichetta, testo e indirizzo di
     ritorno; il box resta visibile solo sulle taglie esaurite.
   - ritorno dopo l'iscrizione: mostra "Fatto" e ripulisce l'indirizzo. Due casi:
       ?avvisami=ok (ritorno diretto) oppure ?customer_posted=true#<id modulo> (dopo il
       CAPTCHA Shopify perde la parte finale dell'indirizzo: taglia, testo e SMS si
       recuperano da sessionStorage, salvati al momento dell'invio). */
(function () {
  if (window.__reavenAvvisami) return;
  window.__reavenAvvisami = true;

  function normalizzaCellulare(valore) {
    var cifre = String(valore || '').replace(/\D/g, '');
    if (cifre.indexOf('0039') === 0) cifre = cifre.slice(4);
    else if (cifre.indexOf('39') === 0 && cifre.length > 10) cifre = cifre.slice(2);
    return /^3\d{8,9}$/.test(cifre) ? '39' + cifre : '';
  }

  class AvvisamiBox extends HTMLElement {
    connectedCallback() {
      if (this._pronto) return;
      this._pronto = true;
      this.tags = this.querySelector('[data-avvisami-tags]');
      this.ritorno = this.querySelector('[data-avvisami-return]');
      this.sms = this.querySelector('[data-avvisami-sms]');
      this.rigaTelefono = this.querySelector('[data-avvisami-phone-row]');
      this.telefono = this.querySelector('[data-avvisami-phone]');
      this.testo = this.querySelector('[data-avvisami-text]');
      this.formWrap = this.querySelector('[data-avvisami-form-wrap]');
      this.fatto = this.querySelector('[data-avvisami-done]');
      this.fattoTesto = this.querySelector('[data-avvisami-done-text]');
      this.fattoSms = this.querySelector('[data-avvisami-done-sms]');

      if (this.sms) {
        this.sms.addEventListener('change', () => {
          this.rigaTelefono.hidden = !this.sms.checked;
          this.telefono.required = this.sms.checked;
          if (this.sms.checked) this.telefono.focus();
          this.aggiornaEtichette();
        });
      }
      if (this.telefono) {
        this.telefono.addEventListener('input', () => {
          this.telefono.setCustomValidity('');
          this.aggiornaEtichette();
        });
        this.telefono.addEventListener('invalid', () => {
          this.telefono.setCustomValidity(this.dataset.phoneError || '');
        });
      }
      var modulo = this.querySelector('form');
      if (modulo) {
        modulo.addEventListener('submit', () => {
          try {
            sessionStorage.setItem('reaven:avvisami', JSON.stringify({
              form: modulo.id,
              sms: !!(this.sms && this.sms.checked && normalizzaCellulare(this.telefono.value)),
              testo: this.fattoTesto ? this.fattoTesto.textContent : '',
              variante: new URL(this.ritorno.value, window.location.origin).searchParams.get('variant') || '',
              quando: Date.now()
            }));
          } catch (e) {
            /* navigazione privata: pazienza, resta il ritorno diretto */
          }
        });
      }

      var ancora = this.querySelector('[data-avvisami-again]');
      if (ancora) ancora.addEventListener('click', () => this.mostraModulo());

      /* PUB_SUB_EVENTS e' una const globale di Dawn (constants.js): non sta su window */
      if (this.dataset.mode !== 'launch' && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (evento) => this.suCambioTaglia(evento));
      }

      this.controllaRitorno();
    }

    disconnectedCallback() {
      if (this.unsubscribe) this.unsubscribe();
    }

    aggiornaEtichette() {
      if (!this.tags) return;
      var base = this.tags.dataset.base;
      var numero = this.sms && this.sms.checked ? normalizzaCellulare(this.telefono.value) : '';
      this.tags.value = numero ? base + ',sms-' + numero : base;
      if (this.ritorno) {
        var url = new URL(this.ritorno.value, window.location.origin);
        if (numero) url.searchParams.set('sms', '1');
        else url.searchParams.delete('sms');
        this.ritorno.value = url.pathname + url.search;
      }
    }

    suCambioTaglia(evento) {
      var dati = evento && evento.data;
      if (!dati || !dati.variant) return;
      var box = this.id && this.id.replace('Avvisami-', '');
      if (dati.sectionId && box && dati.sectionId !== box) return;

      var variante = dati.variant;
      this.hidden = !!variante.available;
      if (variante.available) return;

      this.tags.dataset.base = 'notify-me,avvisami-' + variante.id + (this.dataset.lingua ? ',' + this.dataset.lingua : '');
      var url = new URL(this.dataset.productUrl, window.location.origin);
      url.searchParams.set('variant', variante.id);
      url.searchParams.set('avvisami', 'ok');
      this.ritorno.value = url.pathname + url.search;
      this.aggiornaEtichette();

      if (this.dataset.sizeOption === 'true' && variante.option1) {
        this.testo.textContent = this.dataset.textSize.replace('__TAGLIA__', variante.option1);
        this.fattoTesto.textContent = this.dataset.doneSize.replace('__TAGLIA__', variante.option1);
      }
      this.mostraModulo();
    }

    mostraModulo() {
      this.formWrap.hidden = false;
      this.fatto.hidden = true;
    }

    controllaRitorno() {
      var parametri = new URLSearchParams(window.location.search);
      var modulo = this.querySelector('form');
      var diretto = parametri.get('avvisami') === 'ok';
      var dopoCaptcha = parametri.get('customer_posted') === 'true' && modulo && window.location.hash === '#' + modulo.id;
      if (!diretto && !dopoCaptcha) return;

      var salvato = null;
      try {
        salvato = JSON.parse(sessionStorage.getItem('reaven:avvisami') || 'null');
        sessionStorage.removeItem('reaven:avvisami');
      } catch (e) {
        salvato = null;
      }
      if (salvato && (salvato.form !== (modulo && modulo.id) || Date.now() - salvato.quando > 30 * 60 * 1000)) salvato = null;

      this.hidden = false;
      this.formWrap.hidden = true;
      this.fatto.hidden = false;
      if (salvato && salvato.testo && this.fattoTesto) this.fattoTesto.textContent = salvato.testo;
      if (this.fattoSms) this.fattoSms.hidden = !(parametri.get('sms') === '1' || (salvato && salvato.sms));

      parametri.delete('avvisami');
      parametri.delete('sms');
      parametri.delete('customer_posted');
      if (salvato && salvato.variante && !parametri.get('variant')) parametri.set('variant', salvato.variante);
      var pulito = window.location.pathname + (parametri.toString() ? '?' + parametri.toString() : '');
      try {
        window.history.replaceState(window.history.state, '', pulito);
      } catch (e) {
        /* indirizzo non modificabile: pazienza */
      }
    }
  }

  if (!customElements.get('avvisami-box')) customElements.define('avvisami-box', AvvisamiBox);
})();
